import { useTranslation } from 'react-i18next'
import type { ComponentProgressDetailView } from '@/types/coaching'
import { PartialDataFallback } from './parts/PartialDataFallback'
import { ToonPanelList } from './parts/ToonPanelList'

interface Props {
  component: ComponentProgressDetailView
}

export function ToonCoachingDetail({ component }: Props) {
  const { t } = useTranslation('coaching')
  const toon = component.toon
  if (!toon) return <PartialDataFallback type="toon" />

  const hasIntro = !!toon.intro?.length
  const hasOutro = !!toon.outro?.length

  return (
    <div className="space-y-3">
      {hasIntro && <ToonPanelList stage="intro" panels={toon.intro!} />}
      {hasOutro && <ToonPanelList stage="outro" panels={toon.outro!} />}
      {!hasIntro && !hasOutro && (
        <p className="rounded-md border border-gray-200 bg-white p-4 text-xs italic text-gray-500">
          {t('placeholder.noPanels')}
        </p>
      )}
    </div>
  )
}
